export default __webpack_public_path__ + "static/media/round_loading_bar_purple.bb3aa67d.gif";